import {Component, computed, input, output} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {FormControl} from '@angular/forms';
import {startWith, switchMap} from 'rxjs';
import {TodoCompletion, TodoSummary} from '../../../../../../api';
import {DevDirective} from '../../../../../directives/dev.directive';

@Component({
  selector: 'elcia-todo-picker-item',
  imports: [
    DevDirective,
  ],
  templateUrl: './todo-picker-item.html',
  styleUrl: './todo-picker-item.scss',
})
export class TodoPickerItem {
  todo = input.required<TodoSummary>();
  control = input.required<FormControl<number | null>>();

  onTodoSelect = output<TodoSummary | null>();
  private controlValue = toSignal(
    toObservable(this.control).pipe(
      switchMap(ctrl => ctrl.valueChanges.pipe(startWith(ctrl.value)))
    )
  );

  isSelected = computed(() => this.controlValue() === this.todo().id);
  isDone = computed(() => this.todo().completion === TodoCompletion.DONE);

  select() {
    this.control().setValue(this.isSelected() ? null : this.todo().id);
    this.onTodoSelect.emit(this.isSelected() ? this.todo() : null);
  }
}
